export default "__VITE_ASSET__DGEx3mtw__"